<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-if="theUserProject == 0" v-model="theProjectId" @change="theProjectAllChange" size="small"
          clearable placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>
        <el-input v-model="getCaseRecommendList_data.crTitle" placeholder="请输入标题" clearable size='small'
          style="max-width:200px;" />
        <el-cascader ref='cascader' v-model="getCaseRecommendList_data.srId" clearable filterable size='small'
          placeholder='请选择区域' :show-all-levels='false'
          :options="getSysRegionList_data ? getSysRegionList_data.data : []"
          :props="{ expandTrigger: 'hover', checkStrictly: true, emitPath: false, label: 'srName', value: 'srId', children: 'children' }"
          @change="$refs.cascader.dropDownVisible = false">
          <template slot-scope="{ data }">
            <span onclick="this.parentNode.previousElementSibling.click()">{{ data.srName }}</span>
          </template>
        </el-cascader>
        <el-select v-model='theCrcId' clearable filterable size="small" @change="theCrcIdChange">
          <el-option v-for="item in getCaseRecommendClassList_data.data || []" :key="item.crcId" :label="item.crcName"
            :value="item.crcId">
          </el-option>
        </el-select>
        <el-select v-model='thecrStatus' clearable placeholder="选择微课状态" size="small" @change="thecrStatusChange">
          <el-option label="待发布" :value="1"></el-option>
          <el-option label="已发布" :value="2"></el-option>
          <el-option label="下架" :value="3"></el-option>
        </el-select>
        <el-button @click="getData" type="primary" icon='el-icon-search' size='small' style='margin-left:10px;'>搜索
        </el-button>
      </el-col>
      <el-col :span="6">
        <el-button v-if="addCaseRecommend" @click=" $form('addCaseRecommend')" size='small' type="primary"
          style="float:right" icon='el-icon-circle-plus'>添加推荐案例
        </el-button>
      </el-col>
    </el-row>

    <mytable :tableColums='tableColums_getCaseRecommendList' api='getCaseRecommendList' xupdateapi='updateCaseRecommend'
      :height="H - 165">
      <icol slot='crCover' :showtooltip='false' img='crCover' />
      <icol slot='crPath' :showtooltip='false' img='crPath' />
      <icol slot='crOutline' :showtooltip='false' img='crOutline' />
    </mytable>
    <myform :viewobj='{
      updateCaseRecommendCopy: ["复制到其他项目", "el-icon-edit-outline"],
      $succeed$: getYcToolsAiBaseList
    }' @closed="$form('updateCaseRecommendCopy', 'reset'), window.sleep(50, v => Myformdata)
      ">
      <template v-slot:projectId="{ Myformdata }">
        <el-select v-model="Myformdata.projectId" clearable placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>
      </template>
      <hide slot='crId' />
    </myform>
    <myform :viewobj='{
      addCaseRecommend: ["新增推荐案例信息", "el-icon-circle-plus"],
      updateCaseRecommend: ["修改推荐案例信息", "el-icon-edit-outline"],
      $succeed$: getCaseRecommendList
    }' @closed="$form('updateCaseRecommend', 'reset');
    window.sleep(50, v => Myformdata && (Myformdata.crCover = Myformdata.crPath = Myformdata.crOutline = ''))"
      @confirm='submitForm => $trigger("fileUpload").trigger(res => res && submitForm())'>
      <hide slot='crId' />
      <template v-slot:crCover='{ Myformdata }'>
        <myupload v-event.fileUpload='`
            return (Myformdata.crCover+"").startsWith("http")
              || ( (C = (await C.MyUpload()).file) ? Myformdata.crCover = C : false )
          `' @change='Myformdata.crCover = ($file$ = arguments[0]).url'
          @remove='window.sleep(150, v => Myformdata.crCover = "")' type='image' :limit='1' :params='{ file: "$file$" }'
          :filelist="Myformdata.crCover && Myformdata.crCover != ' '
            ? ({ name: Myformdata.crCover, url: Myformdata.crCover })
            : false
            " :style="{ height: Myformdata.crCover && $form('updateCaseRecommend', 'ifshow') ? '250px' : '' }">
        </myupload>
      </template>
      <template v-slot:crVideoPath='{ Myformdata }'>
        <myupload v-event.fileUpload='`
            return (Myformdata.crVideoPath+"").startsWith("http")
              || ( (C = (await C.MyUpload()).file) ? Myformdata.crVideoPath = C : false )
          `' @change='Myformdata.crVideoPath = ($file$ = arguments[0]).url'
          @remove='window.sleep(150, v => Myformdata.crVideoPath = "")' type='video' :innerList='false' :limit='1'
          :params='{ file: "$file$" }' :filelist="Myformdata.crVideoPath && Myformdata.crVideoPath != ' '
            ? ({ name: Myformdata.crVideoPath, url: Myformdata.crVideoPath })
            : false
            " :style="{ height: Myformdata.crVideoPath && $form('updateBusinessIntroduce', 'ifshow') ? '250px' : '' }">
        </myupload>
      </template>
      <template v-slot:crPath='{ Myformdata }'>
        <myupload v-event.fileUpload='`
            return (Myformdata.crPath+"").startsWith("http")
              || ( (C = (await C.MyUpload()).file) ? Myformdata.crPath = C : false )
          `' @change='Myformdata.crPath = ($file$ = arguments[0]).url'
          @remove='window.sleep(150, v => Myformdata.crPath = "")' type='image' :limit='1' :params='{ file: "$file$" }'
          :filelist='Myformdata.crPath
            ? ({ name: Myformdata.crPath, url: Myformdata.crPath })
            : false
            ' :style="{ height: Myformdata.crPath && $form('updateCaseRecommend', 'ifshow') ? '250px' : '' }">
        </myupload>
      </template>
      <template v-slot:crOutline='{ Myformdata }'>
        <myupload v-event.fileUpload='`
            return (Myformdata.crOutline+"").startsWith("http")
              || ( (C = (await C.MyUpload()).file) ? Myformdata.crOutline = C : false )
          `' @change='Myformdata.crOutline = ($file$ = arguments[0]).url'
          @remove='window.sleep(150, v => Myformdata.crOutline = "")' type='image' :limit='1'
          :params='{ file: "$file$" }' :filelist='Myformdata.crOutline
            ? ({ name: Myformdata.crOutline, url: Myformdata.crOutline })
            : false
            ' :style="{ height: Myformdata.crOutline && $form('updateCaseRecommend', 'ifshow') ? '250px' : '' }">
        </myupload>
      </template>
      <template v-slot:crTime='{ Myformdata }'>
        <el-date-picker v-model="Myformdata.crTime" type="date" value-format='yyyy-MM-dd' placeholder="选择日期">
        </el-date-picker>
      </template>
      <template v-slot:crDes="{ Myformdata }">
        <el-input :rows="3" v-model='Myformdata.crDes' type="textarea" placeholder="请输入产品描述"></el-input>
      </template>
      <template v-slot:crcId="{ Myformdata }">
        <el-select v-model='Myformdata.crcId' clearable filterable>
          <el-option v-for="item in getCaseRecommendClassList_data.data || []" :key="item.crcId" :label="item.crcName"
            :value="item.crcId">
          </el-option>
        </el-select>
      </template>
      <template v-slot:srId="{ Myformdata }">
        <el-cascader ref='cascader' v-model="Myformdata.srId" clearable filterable size='small' placeholder='请选择区域'
          :show-all-levels='false' :options="getSysRegionList_data ? getSysRegionList_data.data : []"
          :props="{ expandTrigger: 'hover', checkStrictly: true, emitPath: false, label: 'srName', value: 'srId', children: 'children' }"
          @change="$refs.cascader.dropDownVisible = false">
          <template slot-scope="{ data }">
            <span onclick="this.parentNode.previousElementSibling.click()">{{ data.srName }}</span>
          </template>
        </el-cascader>
      </template>
    </myform>

    <myform view.getCaseRecommendOutlineList='课程题纲' id='FormTop' top='20px'
      @close='$form("getCaseRecommendOutlineList", "hide")'>
      <hide slot='croId' />
      <hide slot='crId' />
      <hide slot='pageSize' />
      <hide slot='currentPage' />
      <div>
        <el-button v-if="addCaseRecommendOutline" @click="$form('addCaseRecommendOutline')" size='small' type="primary"
          style="float:right" icon='el-icon-circle-plus'>添加课程题纲
        </el-button>
      </div>
      <mytable ref="getCaseRecommendOutlineList" :tableColums='tableColums_getCaseRecommendOutlineList'
        api='getCaseRecommendOutlineList' xupdateapi='updateOpportunityBusinessCheckImage' :height="H - 165">
      </mytable>
    </myform>
    <myform :viewobj='{
      addCaseRecommendOutline: ["新增课程题纲", "el-icon-circle-plus"],
      updateCaseRecommendOutline: ["修改课程题纲息", "el-icon-edit-outline"],
      $succeed$: getCaseRecommendOutlineList
    }' @closed="$form('updateCaseRecommend', 'reset');
    window.sleep(50, v => Myformdata && (Myformdata.crCover = Myformdata.crCover = ''))" @confirm='Form'>
      <hide slot='croId' />
      <hide slot='crId' />
      <template v-slot:croDes="{ Myformdata }">
        <el-input :rows="3" v-model='Myformdata.croDes' type="textarea" placeholder="请输入介绍描述"></el-input>
      </template>
      <template v-slot:croTitle="{ Myformdata }">
        <el-input :rows="3" v-model='Myformdata.croTitle' type="textarea" placeholder="请输入标题总结"></el-input>
      </template>
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      theProjectId: '',
      theId: 0,
      theCrcId: '',
      crId: null,
      thecrStatus: '',
      tableColums_getCaseRecommendOutlineList: {
        $selection: false,
        crTitle: '标题',
        croProgressAt: '当前秒数进度',
        croTitle: ['标题总结', 120],
        croDes: ['介绍描述', 150],
        createtime: '创建时间',
        $operation: [
          '操作', 200,
          this.updateCaseRecommendOutline && `@text: 编辑#warn
           @click: $form("updateCaseRecommendOutline",$row)
          `,
          this.deleteCaseRecommendOutline && `@text: 删除#danger
           @click: _confirm('确定要删除该推荐案例吗?')
                   .trigger('deleteCaseRecommendOutline',{croId:$row.croId})
                   .trigger('getCaseRecommendOutlineList')
          `,
        ],
      },
      tableColums_getCaseRecommendList: {
        $selection: false,

        crTitle: '标题',
        srName: '区域',
        crcName: '案例分类',
        crCover: '封面',
        crOutline: '题纲图片',
        crPath: '内容',
        crDesTitle: ['介绍标题', 120],
        crDes: ['介绍内容', 150],
        crIntroduceTitle: ['释义标题', 120],
        crIntroduce: ['释义内容', 150],
        crClick: '点击次数',
        // crUp: '赞',
        // crDown: '踩',
        crStatus: ['状态', , '@v-if: 1:待发布#danger, 2:已发布#success,3:下架#danger+'],
        createtime: ['创建时间', 150],

        $operation: [
          '操作', 400,
          this.updateCaseRecommendCopy && `@text: 复制到其他项目#primary
                    @click: $form("updateCaseRecommendCopy",$row)
          `,
          this.getCaseRecommendOutlineList && `@text: 课程题纲#warn
           @click: $form("getCaseRecommendOutlineList",$row),getCaseRecommendOutlineList({crId:$row.crId}),theId=$row.crId
          `,
          `@text: 播放#success
           @click: document.PreviewVideo($row.crVideoPath)
          `,
          this.updateCaseRecommend && `@text: 编辑#warn
           @click: $form("updateCaseRecommend",$row)
          `,
          this.deleteCaseRecommend && `@text: 删除#danger
           @click: _confirm('确定要删除该推荐案例吗?')
                   .trigger('deleteCaseRecommend',{crId:$row.crId})
                   .trigger('getCaseRecommendList')
          `,
          this.updateCaseRecommendUp && `@text: 上架#success
           @click: _confirm('确定要上架该微课吗?')
                   .trigger('updateCaseRecommendUp',{crId :$row.crId })
                   .trigger('getCaseRecommendList')
          `,
          this.updateCaseRecommendDown && `@text: 下架#danger
           @click: _confirm('确定要下架该微课吗?')
                   .trigger('updateCaseRecommendDown',{crId :$row.crId })
                   .trigger('getCaseRecommendList')
          `,
        ],

      },

    };
  },

  watch: {

  },

  methods: {
    Form(submit, Myformdata) {
      this.Myformdata.crId = this.theId;
      console.log(this.Myformdata.crId);


      submit();
    },
    theCrcIdChange(e) {
      this.theCrcId = e;
      this.getCaseRecommendList({ crcId: e });
    },
    thecrStatusChange(e) {
      this.thecrStatus = e;
      this.getCaseRecommendList({ crStatus: e });
    },
    theProjectAllChange(e) {
      this.theProjectId = e;
      this.getCaseRecommendList({
        ...this.getCaseRecommendList_data,
        projectId: this.theProjectId
      })
    },
    getData() {
      this.getCaseRecommendList({
        ...this.getCaseRecommendList_data,
        projectId: this.theProjectId
      })
    }
  },

  created() {
    this.getCaseRecommendList();
    this.getCaseRecommendClassList({ pageSize: 0 });
    this.theUserProject = A.local("$projectId");
    if (this.theUserProject == 0) {

    } else {
      this.theProjectId = this.theUserProject;
    }
    this.getProjectList({
      pageSize: 0
    });
    this.getSysRegionList()
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/help/CaseRecommend.vue